import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchToursDates } from "../../api/toursApi";
import toast from "react-hot-toast";
// import { fetchToursDates } from "../../../lib/service/tours/api"; // Adjust the path as necessary

// Async thunk for fetching available tour dates
export const fetchToursDatesThunk = createAsyncThunk(
  "toursAvailableDates/fetchToursDates",
  async ({ all, logout }, { rejectWithValue }) => {
    try {
      const response = await fetchToursDates({ all });
      if (!response.data.status) {
        toast.error("Your session has expired");
        setTimeout(() => {
          window.location.replace("/");
          logout();
        }, 1500);
        throw new Error(response.data.message);
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  availableDates: [],
  loading: false,
  error: null,
};

// Slice
const toursAvailableDatesSlice = createSlice({
  name: "toursAvailableDates",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchToursDatesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchToursDatesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.availableDates = action.payload;
      })
      .addCase(fetchToursDatesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError } = toursAvailableDatesSlice.actions;
export default toursAvailableDatesSlice.reducer;
